// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_color1.less
// module id = ./resources/assets/less/app_color1.less
// module chunks = 0